/**
 * Empty-state placeholder for tables and lists.
 */
import React from "react";
import { Box } from "@mui/material";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";

import { VText } from "form";

/**
 * Centered "no data" message.
 */
const BEmpty = () => {
  const { t } = useTranslation("common");

  return (
    <>
      <Box className="flex justify-center items-center w-full h-full">
        <Box className="w-2/3 flex justify-center dark:bg-gray-700 items-center h-20 md:h-40 rounded-lg bg-gray-50 px-4" sx={{ maxWidth: "500px" }}>
          <VText color="secondary" className="flex items-center text-base md:text-2xl">
            <Icon className="text-2xl md:text-5xl flex-shrink-0" icon="icon-park-twotone:speed-one" />
            &nbsp;
            {t("No data to be shown")}
          </VText>
        </Box>
      </Box>
    </>
  );
};

export default BEmpty;
